import { render } from "./VaBeneCategorieListPage.vue?vue&type=template&id=978010c2&ts=true"
import script from "./VaBeneCategorieListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneCategorieListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__